export const RecoilAtomKeys = {
  LOADING: 'loading',
  SNACKBAR: 'snackbar',
} as const
